webpackJsonp([213720915766396],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underConstruction = __webpack_require__(70);
	
	var _underConstruction2 = _interopRequireDefault(_underConstruction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Projects'
	    ),
	    _react2.default.createElement('img', { style: { height: '100%', width: '100%' }, src: _underConstruction2.default }),
	    _react2.default.createElement(
	      'form',
	      { name: 'test', netlify: true },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Name ',
	          _react2.default.createElement('input', { type: 'text', name: 'name' })
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'label',
	          null,
	          'Email ',
	          _react2.default.createElement('input', { type: 'email', name: 'email' })
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'button',
	          { type: 'submit' },
	          'Send'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-6664dbd05eebfc61f17c.js